
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"30.593","width":"30.593","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.099 4.439l-2.1 26.154h4.673L6.431 4.439z","fill":"#079ba7"}}),_c('path',{attrs:{"d":"M27.841 5.907h-6.33V.001H6.731l-.3 4.439-1.754 26.153h24.58zm-3.923 13.85H10.162l.079-1.708h13.6zm-.318-6.886l.079 1.708H10.401l.079-1.708zM9.923 24.945l.079-1.708h14.075l.079 1.708z","fill":"#03747d"}}),_c('path',{attrs:{"d":"M27.842 5.907L21.513.001v5.908z","fill":"#6ac3ca"}}),_c('path',{attrs:{"d":"M10.48 12.87l-.079 1.708h13.278L23.6 12.87zM10.238 18.048l-.079 1.708h13.759l-.079-1.708zM10.001 23.236l-.079 1.708h14.235l-.079-1.708z","fill":"#fff"}})])
          )
        }
      }
    